import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";

export default function ConfettiBurst({ trigger }) {
  const [show, setShow] = useState(false);
  const [size, setSize] = useState({ w: window.innerWidth, h: window.innerHeight });

  useEffect(() => {
    const handler = () => setSize({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  useEffect(() => {
    if (trigger) {
      setShow(true);
      const t = setTimeout(() => setShow(false), 2800);
      return () => clearTimeout(t);
    }
  }, [trigger]);

  if (!show) return null;
  return <Confetti width={size.w} height={size.h} numberOfPieces={220} recycle={false} gravity={0.25}/>;
}
